import { addContour } from './art-direction.js';
import { makeRig, compact } from './model-kit.js';
export { material } from './model-kit.js';
import { humans } from './characters-humans.js';
import { creatures } from './characters-creatures.js';
import { festive } from './characters-festive.js';
const builders={...humans,...creatures,...festive};

export function createCharacter(id,{merge=true}={}) {
  if(!builders[id])throw new Error(`Unknown character: ${id}`);
  const r=makeRig();builders[id](r);
  if(merge)for(const bone of [r.body,r.head,r.la,r.ra,r.ll,r.rl])if(bone.visible){compact(bone);addContour(bone);}
  r.root.userData.rig=r;r.root.userData.character=id;
  return r.root;
}
export function animateCharacter(root,time,speed=0,attack=0,stunned=false) {
  const r=root.userData.rig;if(!r)return;
  const walk=Math.min(speed/4.5,1.7),phase=time*10,breath=Math.sin(time*2.5)*.02;
  root.position.y+=Math.abs(Math.sin(phase))*.065*walk;
  r.body.position.y=breath;r.head.position.y=(root.userData.character==='cowboy'?2.72:root.userData.character==='yeti'?2.42:2.25)+breath;
  r.head.rotation.z=stunned?Math.sin(time*20)*.08:Math.sin(time*1.1)*.025;
  r.ll.rotation.x=Math.sin(phase)*.62*walk;r.rl.rotation.x=-Math.sin(phase)*.62*walk;
  r.la.rotation.x=-Math.sin(phase)*.36*walk-attack*.35;r.ra.rotation.x=Math.sin(phase)*.36*walk-attack*.8;
  r.la.rotation.z=-.09-Math.sin(time*1.8)*.025;r.ra.rotation.z=.09+Math.sin(time*1.8)*.025;
}
export function disposeCharacter(root) {
  root.traverse(o=>{if(o.isMesh)o.geometry.dispose();});
  root.removeFromParent();
}
